import { render, staticRenderFns } from "./product_country_of_origin.vue?vue&type=template&id=07e24d53&scoped=true&"
import script from "./product_country_of_origin.vue?vue&type=script&lang=js&"
export * from "./product_country_of_origin.vue?vue&type=script&lang=js&"
import style0 from "./product_country_of_origin.vue?vue&type=style&index=0&id=07e24d53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e24d53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e24d53')) {
      api.createRecord('07e24d53', component.options)
    } else {
      api.reload('07e24d53', component.options)
    }
    module.hot.accept("./product_country_of_origin.vue?vue&type=template&id=07e24d53&scoped=true&", function () {
      api.rerender('07e24d53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_country_of_origin.vue"
export default component.exports